            var searchInput = document.getElementById('SearchInput--desktop');
            var predictiveSearch = document.querySelector('.custom-suggestion--desktop');
  var predictiveSearch2 = document.querySelector('.prev_predictive_search--desktop');
            var searchReset = document.getElementById('search-reset-desktop');
            searchInput.addEventListener('focus', function() {
              setTimeout(function() {
                document.body.classList.add('searchopen');
              },1200);
              
                predictiveSearch.style.display = 'block';
               predictiveSearch2.style.display = 'block';
                 predictiveSearch.style.opacity = '1';
                predictiveSearch.style.visibility = 'visible';
                searchReset.classList.remove('hidden');
              
            });
            searchInput.addEventListener('input', function() {
                var valueLength = this.value.length;
setTimeout(function() {
  searchReset.classList.remove('hidden');
                  if (valueLength > 0) {
                    predictiveSearch.style.display = 'none';
                } else {
                    predictiveSearch.style.display = 'block';
                }
},500);
 

            });
            var MobilesearchInput = document.getElementById('SearchInput--mobile');
            var MobilepredictiveSearch = document.querySelector('.custom-suggestion--mobile');
var MobilepredictiveSearch2 = document.querySelector('.prev_predictive_search--mobile');
            var MobilesearchReset = document.getElementById('search-reset-mobile');

            MobilesearchInput.addEventListener('focus', function() {

                MobilepredictiveSearch2.style.display = 'block';
              MobilepredictiveSearch.style.display = 'block';
                 MobilepredictiveSearch.style.opacity = '1'; 
                MobilepredictiveSearch.style.visibility = 'visible';
                            setTimeout(function() {
                document.body.classList.add('searchopen');
              },1200);
                MobilesearchReset.classList.remove('hidden');
            });
  $(document).mouseup(function (e) { 
if ($(e.target).closest(".header__mobile__button").length === 0) { 
MobilepredictiveSearch2.style.display = 'none';
MobilepredictiveSearch.style.display = 'none';
MobilepredictiveSearch.style.opacity = '0'; 
MobilepredictiveSearch.style.visibility = 'hidden';
document.body.classList.remove('searchopen');
  MobilesearchReset.classList.add('hidden');
            } 
        }); 

            MobilesearchInput.addEventListener('keyup', function() {
                MobilesearchReset.classList.remove('hidden');
            });
          
            MobilesearchInput.addEventListener('input', function() {
                var valueLength = this.value.length;
setTimeout(function() {
                  if (valueLength > 0) {
                    MobilepredictiveSearch.style.display = 'none';
                      // MobilesearchReset.classList.remove('hidden'); 
                } else {
                    MobilepredictiveSearch.style.display = 'block'; 
                    // MobilesearchReset.classList.add('hidden');
                }
},500);
 

            });



document.addEventListener("click", function(event) {
    if (event.target.matches("button#search-reset-desktop")) {
        event.target.classList.add("hidden");
        document.querySelector(".custom-suggestion--desktop").style.display = "none";
       document.querySelector(".prev_predictive_search--desktop").style.display = "none";
        const input = event.target.closest(".input-holder").querySelector("input");
  document.body.classList.remove('searchopen');
        if (input) {
            input.value = '';
           localStorage.removeItem("searchValue");
        }
    }
});

document.addEventListener("click", function(event) {
    if (event.target.matches("button#search-reset-mobile")) {
        event.target.classList.add("hidden");
      document.body.classList.remove('searchopen');
        document.querySelector(".custom-suggestion--mobile").style.display = "none";
       document.querySelector(".prev_predictive_search--mobile").style.display = "none";
        const input = event.target.closest(".input-holder").querySelector("input");
        if (input) {
            input.value = '';
           localStorage.removeItem("searchValue");
        }
    }
});
let debounceTimer;
let controller = new AbortController();

document.getElementById("SearchInput--desktop").addEventListener("keyup", function() {
    clearTimeout(debounceTimer);
    var datain = this.value;
    if (datain.length === 0) {
        const suggestionsElement = document.querySelector(".related_suggestion_custom");
        if (suggestionsElement) {
            suggestionsElement.innerHTML = ''; 
        }
        return;
    }
  var related_serches_heading = $(".related_serches_heading").html();
    debounceTimer = setTimeout(function() {
        controller.abort();
        controller = new AbortController();
        fetch(window.Shopify.routes.root + "search/suggest.json?q=" + datain + "&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title", {
            signal: controller.signal
        })
        .then(response => response.json())
        .then(suggestions => {
            const productSuggestions = suggestions.resources.results;
            var related_suggestion = '';
           related_suggestion += '<p class="predictive-search__heading">'+related_serches_heading+'</p>'
            for (let i = 0; i < productSuggestions.collections.length; i++) {
                related_suggestion += '<div class="predictive-search__item" id="predictive-search-option-collection-' + i + '" role="option" aria-selected="false"><a class="predictive-search__link" href="' + productSuggestions.collections[i].url + '" tabindex="-1">' + productSuggestions.collections[i].title + '</a></div>';
            }
            for (let s = 0; s < productSuggestions.products.length; s++) {
                related_suggestion += '<div class="predictive-search__item" id="predictive-search-option-product-' + s + '" role="option" aria-selected="false"><a class="predictive-search__link" href="' + productSuggestions.products[s].url + '" tabindex="-1">' + productSuggestions.products[s].title + '</a></div>';
            }
            const suggestionsElement = document.querySelector(".related_suggestion_custom");
            if (suggestionsElement) {
                setTimeout(function() {
                    suggestionsElement.innerHTML = related_suggestion;
                }, 200);
            }
        })
        .catch(error => {
            if (error.name !== 'AbortError') {
                console.error('Fetch error:', error);
            }
        });
    }, 300);
});




document.getElementById("SearchInput--mobile").addEventListener("keyup", function() {
    clearTimeout(debounceTimer);
    var datain = this.value;
    if (datain.length === 0) {
        const suggestionsElement = document.querySelector(".related_suggestion_custom");
        if (suggestionsElement) {
            suggestionsElement.innerHTML = ''; 
        }
        return;
    }
    debounceTimer = setTimeout(function() {
        controller.abort();
        controller = new AbortController();
        fetch(window.Shopify.routes.root + "search/suggest.json?q=" + datain + "&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title", {
            signal: controller.signal
        })
        .then(response => response.json())
        .then(suggestions => {
            const productSuggestions = suggestions.resources.results;
            var related_suggestion = '';
           related_suggestion += '<p class="predictive-search__heading">Related Search</p>'
            for (let i = 0; i < productSuggestions.collections.length; i++) {
                related_suggestion += '<div class="predictive-search__item" id="predictive-search-option-collection-' + i + '" role="option" aria-selected="false"><a class="predictive-search__link" href="' + productSuggestions.collections[i].url + '" tabindex="-1">' + productSuggestions.collections[i].title + '</a></div>';
            }
            for (let s = 0; s < productSuggestions.products.length; s++) {
                related_suggestion += '<div class="predictive-search__item" id="predictive-search-option-product-' + s + '" role="option" aria-selected="false"><a class="predictive-search__link" href="' + productSuggestions.products[s].url + '" tabindex="-1">' + productSuggestions.products[s].title + '</a></div>';
            }
            const suggestionsElement = document.querySelector(".related_suggestion_custom");
            if (suggestionsElement) {
                setTimeout(function() {
                    suggestionsElement.innerHTML = related_suggestion;
                }, 400);
            }
        })
        .catch(error => {
            if (error.name !== 'AbortError') {
                console.error('Fetch error:', error);
            }
        });
    }, 500);
});

 